<template>
  <footer id="footer" class="footer">
    <div class="footer-line">
      <v-container bg="y">
        <v-media
          yAlign="t"
          class="footer-media"
          xAlign="c"
          :halfFilling="false"
        >
          <template v-slot:left>
            <div class="footer-content">
              <v-headline :level="2" class="uppercase"
                >{{ dic.contacts }} {{ dic.brand }}</v-headline
              >

              <v-media
                class="margin text-md"
                :halfFilling="false"
                xAlign="c"
                yAlign="t"
              >
                <template v-slot:left>
                  <div class="plus"></div>
                </template>
                <template v-slot:right>
                  <div>
                    <v-link :href="phoneLink">{{ phone }}</v-link>
                    <p>{{ email }}</p>
                  </div>
                </template>
              </v-media>

              <ul class="margin text-md">
                <li v-for="line of address" :key="line">{{ line }}</li>
              </ul>

              <v-link class="margin text-t" anchor="?ttn">{{
                dic.footer.msg1
              }}</v-link>

              <v-icons class="margin" />
            </div>
          </template>

          <template v-slot:right>
            <v-map />
          </template>
        </v-media>
      </v-container>
    </div>
    <!-- END FOOTER LINE -->
    <div class="footer-line">
      <div class="footer-copyright">
        {{ `© ${foundationYear}&mdash;${currYear} Sovtes` }}
      </div>
    </div>
    <!-- END FOOTER LINE -->
  </footer>
</template>

<script>
import VMap from '@/components/ui/VMap'
import VHeadline from '@/components/ui/VHeadline'
import VContainer from '@/components/ui/VContainer'
import VMedia from '@/components/ui/VMedia'
import VLink from '@/components/ui/VLink'
import VIcons from '@/components/ui/VIcons'
import { LINK_TEL_NUM } from '@/libs/constants'

import { mapState } from 'vuex'

export default {
  name: 'Footer',
  data: () => {
    return {
      phoneLink: `tel:${LINK_TEL_NUM}`,
    }
  },
  components: {
    VContainer,
    VHeadline,
    VMap,
    VMedia,
    VLink,
    VIcons,
  },
  computed: {
    ...mapState('proprietary', [
      'foundationYear',
      'email',
      'phone',
      'address',
      'socialsHref',
    ]),
    currentLang() {
      //this need for wake up store listner 
      return this.$store.state.main.currentLang
    },
    dic() {
      this.currentLang //this need for wake up store listner 
      return this.$store.state.main.dic
    },
    currYear() {
      const date = new Date()
      return date.getFullYear()
    },
  },
}
</script>

<style scoped lang="scss">
.margin {
  margin: 30px 0;
}
</style>

<style scoped lang="scss">
.footer {
  font-weight: 400;
  color: black;

  &-copyright {
    padding: 30px 0;
    background-color: #dcdcdc;
    text-align: center;
  }

  &-content {
    text-align: left;
    line-height: 1.5;
  }

  &-media {
    // max-width: 1100px;
    margin: 0 auto;
    justify-content: center;
  }
}
</style>

<style lang="scss" scoped>
@media (max-width: 910px) {
  .footer {
    &-media {
      flex-wrap: wrap;
      justify-content: center;
    }
  }
}

@media (max-width: 768px) {
}

@media (max-width: 411px) {
}

@media (max-width: 375px), (max-width: 411px) {
  .margin {
    margin: 20px 0;
  }
}
</style>
